import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Rebase',
  operation_name: 'Rebase',
  display_app_name: 'Rebase',
  stylesheet: '/rebase.css',
  favicon: '/rebase_favicon.png',
  base_api_url: 'https://rebase.api.seasideapis.com/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'rebase',
  hr_email: 'hr@rebase.co.il',
  operation_email: 'hr@rebase.co.il',
  preview_link: 'https://web.rebase.co.il/offer_preview/',
  company_panel_url: 'https://companies.rebase.co.il/',
  seo_single_position_path: 'single_position',
  owners: [
    {
      name: 'נינה',
      phone_number: '053-446-2801',
      color: '#ed008c'
    },
    {
      name: 'מעין',
      phone_number: '053-442-8900',
      color: '#05cc47'
    },
    {
      name: 'מאיה',
      phone_number: '053-476-6228',
      color: '#8e43e7'
    },
    {
      name: 'הילה',
      phone_number: '050-671-1675',
      color: '#ee4f4f'
    },
    {
      name: 'נעם',
      phone_number: '053-476-6228',
      color: '#fdca30'
    },
    {
      name: 'שלי',
      phone_number: '053-476-6228',
      color: '#fdca30'
    },
    {
      name: 'שביט',
      phone_number: '053-356-7688',
      color: '#fdca30'
    },
    {
      name: 'הראל',
      phone_number: '050-639-9920',
      color: '#6d6e70'
    },
    {
      name: 'מערכת',
      phone_number: '050-639-9920',
      color: '#49c0b6'
    },
    {
      name: 'פז',
      phone_number: '051-241-0744',
      color: '#8e43e7'
    },
    {
      name: 'עפרי',
      phone_number: '051-566-7299',
      color: '#fdca30'
    },
    {
      name: 'יובל',
      phone_number: '051-264-0834',
      color: '#fdca30'
    }
  ],
  field: 'ההנדסה האזרחית',
  recruitement_field: 'השמת מהנדסים אזרחיים',
  discrete_emoji: '😎',
  icon: '⚡',
  files: {
    is_profile_default_checked: false
  },
  applicant_modal: {
    languages: ['עברית', 'ערבית', 'אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: ['מהנדס ביצוע', 'מנהל פרויקט', 'מתכנן', 'שרטט', 'מנהל עבודה', 'עוזר בטיחות', 'ממונה בטיחות', 'מפקח']
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/rebase_logo_bright.svg',
    logo_dark: '/rebase_logo_dark.svg'
  },
  links: {
    website_url: 'https://www.rebase.co.il/',
    web_base_url: 'https://web.rebase.co.il/',
    app_store_url: 'https://apps.apple.com/il/app/rebase/id1473154558',
    google_play_url: 'https://play.google.com/store/apps/details?id=il.co.rebase'
  },
  hashtags: 'rebase',
  firebase,
  full_env_name: 'rebase_production',
  background_theme: '/rebase_background_theme.jpg'
}
